import { render, staticRenderFns } from "./depositProfile.vue?vue&type=template&id=6051585c"
import script from "./depositProfile.vue?vue&type=script&lang=js"
export * from "./depositProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports